import propTypes from 'prop-types';

import { BaseURL } from '../../../../../base/env';
import CountDown from '../CountDown/CountDown';
import styles from './ContentItem.module.css';

const ContentItem = ({ key, children, data }) => {
  const generateColorStyle = () => {
    const style = {
      backgroundColor: data.title_color
    };
    return style;
  };

  return (
    <div
      key={key}
      className={styles.ContentItem}
      style={{
        backgroundImage: `linear-gradient(to right, ${data.background_color_left}, ${data.background_color_right})`
      }}>
      <div className={styles.HeaderImage}>
        {data.header_image === null ? (
          <div className={styles.WithoutImage} />
        ) : (
          <img alt="" className={styles.Image} src={`${BaseURL + data.header_image}`} />
        )}
      </div>
      {data.title ? (
        <div className={styles.HeaderTimerContainer}>
          <div className={styles.HeaderContainer}>
            {data.title ? (
              <div className={styles.Title} style={generateColorStyle()}>
                <span> {data.title} </span>
                <span className={styles.TitleAfter} />
              </div>
            ) : null}
            <CountDown
              code={data.design.code}
              color={data.design.color}
              ended_at={data.ended_at}
              is_active={data.counter_is_active}
              now={data.now}
              position={data.design.position}
              started_at={data.started_at}
            />
          </div>
        </div>
      ) : null}

      <div className={styles.Children}>{children}</div>
      <div className={styles.FooterImage}>
        {data.footer_image === null ? (
          <div className={styles.WithoutImage} />
        ) : (
          <img alt="" className={styles.Image} src={`${BaseURL + data.footer_image}`} />
        )}
      </div>
    </div>
  );
};

ContentItem.propTypes = {
  title: propTypes.string,
  children: propTypes.any,
  key: propTypes.number
};

export default ContentItem;
